import React from 'react';

export default function BlockerCallbackButton({align, theme, callback, icon, text}) {
  if(!callback) {
    return null;
  }

  align = align || '';
  theme = theme || '';
  icon = icon || '';

  return (
    <button className={`${align} ${theme}`} onClick={callback}>
      <span className={icon}>{text}</span>
    </button>
  )
};
